var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/bimFileSubscriptions.ts";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createEvent, createStore } from 'effector';
import * as smApi from '@gmini/sm-api-sdk';
export var createBimFileSubscriptions = function createBimFileSubscriptions(_ref) {
  var subscribe = _ref.subscribe,
      unsubscribe = _ref.unsubscribe;
  var reset = createEvent({
    name: "reset",
    sid: "dg2wng"
  });
  var subscriptionState$ = createStore(new Set(), {
    name: "subscriptionState$",
    sid: "-4hvqfq"
  }).on(smApi.BimModel.fetchLatestBimFile.doneData, function (state, _ref2) {
    var urn = _ref2.urn;

    if (state.has(urn)) {
      return state;
    }

    subscribe({
      urn: urn
    });
    state.add(urn);
    return state;
  }).on(reset, function (bimFileUrns) {
    if (bimFileUrns.size) {
      bimFileUrns.forEach(function (urn) {
        return unsubscribe({
          urn: urn
        });
      });
      bimFileUrns.clear();
    }

    return bimFileUrns;
  });
  return {
    resetBimFileIds: reset,
    subscriptionState$: subscriptionState$
  };
};